import { Component, Input, Output, EventEmitter } from '@angular/core';
import * as uuid from 'uuid';

@Component({
  selector: 'app-toggle',
  templateUrl: './toggle.component.html'
})
export class ToggleComponent {
  @Input() isSwitch: boolean;
  @Input() label: string;
  @Input() data_testid: string;
  @Input() checked: boolean = false;
  @Output() clicked: EventEmitter<any> = new EventEmitter();
  id = 't' + uuid.v4();

  onClick(event: any) {
    // this.checked = !this.checked;
    const checked = event.target.checked;
    this.checked = checked;
    this.clicked.emit({checked})
  }

}
